<template>
  <div>
    <ul class="pagination pull-right">
      <li :class="{'disabled': pager.currentPage === 1}">
        <a @click="setPage(1)">&laquo;</a>
      </li>
      <li :class="{'disabled': pager.currentPage === 1}">
        <a @click="setPage(pager.currentPage - 1)">&lsaquo;</a>
      </li>
      <li v-for="page in pager.pages" :key="page" class="page-item page-number"
          :class="{'active': pager.currentPage === page}">
        <a class="page-link" @click="setPage(page)">{{ page }}</a>
      </li>
      <li :class="{'disabled': pager.currentPage === pager.totalPages}">
        <a @click="setPage(pager.currentPage + 1)">&rsaquo;</a>
      </li>
      <li :class="{'disabled': pager.currentPage === pager.totalPages}">
        <a @click="setPage(pager.totalPages)">&raquo;</a>
      </li>
    </ul>
  </div>
</template>

<script>
import paginate from 'jw-paginate';

export default {
  name: "Pagination",
  props: ['items', 'storeMutation', 'pageSize', 'maxPages'],
  data() {
    return {
      data: this.$props.items,
      pager: {}
    }
  },
  methods: {
    setPage(page) {
      let data = this.$props.items
      this.pager = paginate(data.length, page, this.$props.pageSize, this.$props.maxPages);
      const pagedItems = data.slice(this.pager.startIndex, this.pager.endIndex + 1);

      this.$store.commit(this.$props.storeMutation, pagedItems)
    }
  },
  mounted() {
    this.setPage(1)
  }
}
</script>

<style scoped>

</style>